var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow > -1
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.dataToShow == 1 ? _c('div', [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Confirmer l'annulation du renouvelement automatique")]), _vm._v(" "), _c('h6', {
    staticClass: "w-full text-center text-indigo-600 mb-5"
  }, [_vm._v("\n                Votre abonnement prendra fin le " + _vm._s(_vm.endDate) + ".\n            ")]), _vm._v(" "), _c('h6', {
    staticClass: "w-full text-center text-indigo-600 mb-10"
  }, [_vm._v("\n                Êtes-vous sûr de vouloir désactiver le renouvelement automatique de votre abonnement ?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center space-x-5"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-100",
      "bg-color-square": "bg-pink-100",
      "icon-color": "text-white",
      "libelle": "Annuler",
      "uppercase": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.close(-1);
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Désactiver",
      "uppercase": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.confirmCancelSubscription();
      }
    }
  })], 1)])]) : _vm.dataToShow == 2 ? _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("Le renouvelement automatique a été annulé !")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("Votre abonnement Neopass s'arrêtera le " + _vm._s(_vm.endDate))]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("Vous pouvez continuer à utiliser l'application Neopass jusqu'à cette date.")])]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "basket"
    }
  })], 1)]) : _vm.dataToShow == 100 ? _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("Erreur lors de l'annulation du renouvelement automatique !")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("Le renouvelement automatique n'a pas pu être annulé.")])]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }